export default "__VITE_ASSET__WDnrq$BE__"